module.exports = __webpack_public_path__ + "static/media/aditya.3bc534fd.png";